import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { sendSubscriptionDetails } from "@TKCCP/Services/tkccpSubscriptionProductsService";
import { CustomApiHandler } from "@TKCCP/Store/CustomHandlerCreator/CustomHandlerCreator";
import { SubscriptionProductIsSelected } from "@TKCCP/Types/ApiModels";

type createSubscriptionParameter = {
    Name: string;
    UserProfileId: string;
    CustomerId: string;
    StartDate: string;
    EndDate: string | null;
    IsActive: boolean;
    NextOrderFrequencyInDays: string;
    CustomerPO: string;
    CustomerVatNumber: string;
    SubscriptionProductsList: SubscriptionProductIsSelected[];
} & HasOnSuccess;

type HandlerType = CustomApiHandler<createSubscriptionParameter, createSubscriptionParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        Name: props.parameter.Name,
        UserProfileId: props.parameter.UserProfileId,
        CustomerId: props.parameter.CustomerId,
        StartDate: props.parameter.StartDate,
        EndDate: props.parameter.EndDate,
        IsActive: props.parameter.IsActive,
        NextOrderFrequencyInDays: props.parameter.NextOrderFrequencyInDays,
        SubscriptionProductsList: props.parameter.SubscriptionProductsList,
        CustomerPO: props.parameter.CustomerPO,
        CustomerVatNumber: props.parameter.CustomerVatNumber,
    };
};

export const SendDataToApi: HandlerType = async props => {
    await sendSubscriptionDetails(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const DispatchInitalSubscriptionProduct: HandlerType = props => {
    props.dispatch({
        type: "Data/SubsriptionProductService/InitalValuesProduct",
    });
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback, DispatchInitalSubscriptionProduct];

const submitCreateSubscriptionForm = createHandlerChainRunner(chain, "submitCreateSubscriptionForm");
export default submitCreateSubscriptionForm;
